import { IAutomationObject } from '../../types'

export interface IShiftFunction extends IAutomationObject {
    lines: 
        {
            name: string,
            points: ShiftFunctionPoint[],
            key: any
        }[]
    yMin: number,
    yMax: number,
}

export type ShiftFunctionPoint = {
    x: number,
    y: number
}

export const schema = 'AutomationApps.Functions.Controllers.ShiftFunction';